module.exports = __webpack_public_path__ + "img/p107.dac905df.png";